/**
 * Challenge Service
 * API client for daily AI-generated challenges
 */

import { apiClient, extractData } from './api';
import type { DailyChallenge } from '@kids-lms/types';

/** Get today's challenge for a child (generates via AI if none exists) */
async function getDailyChallenge(childId: string): Promise<DailyChallenge> {
  const response = await apiClient.get(`/challenges/daily/${childId}`);
  return extractData(response);
}

const challengeService = {
  getDailyChallenge,
};

export default challengeService;
